export class Company {
  name: string;
  city: string;
  street: string;
  zip: number;
  country: string;
  website: string;
  phone: string;
  email: string;
  vat: string;
  tagline: string;
  registry: string;
  gps: string;
  alternate: Company;

  constructor(
    name: string,
    city: string,
    street: string,
    zip: number,
    country: string,
    website: string,
    phone: string,
    email: string,
    vat: string,
    tagline: string,
    registry: string,
    gps: string,
    alternate: Company = null,
  ) {
    this.name = name;
    this.city = city;
    this.street = street;
    this.zip = zip;
    this.country = country;
    this.website = website;
    this.phone = phone;
    this.email = email;
    this.vat = vat;
    this.tagline = tagline;
    this.registry = registry;
    this.gps = gps;
    this.alternate = alternate;
  }

  static arrayFromJSON(json: string): Company {
    const value = JSON.parse(json);
    if (!value) {
      return null;
    }

    let result: Company = null;
    result = Company.createFromAny(value);

    return result;
  }

  static createFromAny(object: any): Company {
    if (object === null || object === undefined) {
      return null;
    }
    return new Company(
      object.name,
      object.city,
      object.street,
      object.zip,
      object.country,
      object.website,
      object.phone,
      object.email,
      object.vat,
      object.tagline,
      object.registry,
      object.gps,
      Company.createFromAny(object.alternate),
    );
  }

  get gps_lat(): number {
    if (!this.gps) {
      return 0;
    }

    const gps = this.gps.split(',');
    if (!gps || gps.length !== 2 || !gps[0]) {
      return 0;
    }

    const lat = gps[0].trim();
    if (!lat) {
      return 0;
    }

    return +gps[0];
  }

  get gps_lng(): number {
    if (!this.gps) {
      return 0;
    }

    const gps = this.gps.split(',');
    if (!gps || gps.length !== 2 || !gps[1]) {
      return 0;
    }

    const lat = gps[1].trim();
    if (!lat) {
      return 0;
    }

    return +gps[1];
  }
}
